<!--
* www.cloudscope.cn
* Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 11:57:16
 * @Description: 用户表格
-->
<template>
    <div class="table-list">
        <div class="header">
            <p class="title">{{title}}</p>
        </div>
        <el-table
            size="mini"
            :data="tableData"
            class="mod-table"
            style="margin-top:19px"
            height="250"
            v-loading="loading"
        >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
                type="index"
                align="center"
                width="80"
                label="序号"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="username" align="center" label="用户账号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nickname" align="center" label="用户名称" show-overflow-tooltip></el-table-column>
            <el-table-column
                prop="roleArrayList"
                align="center"
                label="用户角色"
                :formatter="formatter"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="groupArrayList"
                align="center"
                label="所属机构"
                :formatter="formatterGroup"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column align="center" label="状态" width="80" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="small"
                        prop="status"
                        @click="disableOrEnableUser(scope.row)"
                    >{{scope.row.status== 1? "启用":"禁用"}}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="email" align="center" label="用户邮箱" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showDialog(scope.row.id)">编辑</el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="DeleteShow(scope.$index,scope.row.id)"
                    >删除</el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="showAddRole(scope.$index, tableData)"
                    >角色</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 用户分配角色 Dialog: Begin -->
        <el-dialog
            title="配置角色"
            custom-class="mod-dialog"
            append-to-body
            :visible.sync="roleDialogVisible"
            width="50%"
        >
            <el-transfer
                filterable
                class="transfer-wrap"
                v-model="targetKeys"
                :data="notInRole"
                :titles="['待选角色', '已拥有角色']"
                filter-placeholder="输入关键字"
                style="height:450px"
            ></el-transfer>
            <span slot="footer" class="dialog-footer">
                <el-button
                    size="mini"
                    style="width:72px"
                    type="info"
                    @click="roleDialogVisible=false"
                >取消</el-button>
                <el-button
                    size="mini"
                    style="width:72px"
                    type="primary"
                    @click="distributionRole"
                >确定</el-button>
            </span>
        </el-dialog>
        <footer class="main-footer">
            <!-- 底部分页 -->
            <el-pagination
                layout="total, sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @next-click="changePage"
                @prev-click="changePage"
                @current-change="changePage"
            ></el-pagination>
        </footer>
    </div>
</template>

<script>
export default {
    components: {},
    props: ['title'],
    data () {
        return {
            tableData: [],
            loading: false,
            currentPage: 1, // 当前页
            pageSize: 10, // 每页数量
            total: 0, // 总数
            roleDialogVisible: false, // 下发角色展示控制
            targetKeys: [], // 当前编辑用户已拥有的角色
            notInRole: [], // 当前被编辑用户未拥有的角色
            UserForm: {
                // 角色数据
                id: '',
                username: '',
                nickname: '',
                role: '',
                email: '',
                status: ''
            },
            RoleForm: {
                // 角色数据
                id: '',
                name: '',
                code: '001',
                status: 1
            },
            userKey: '', // 用户主键
            getRowKeys (row) {
                return row.id;
            },
            async queryNotInRole (id) {
                // 获取不属于当前用户的角色
                if (id != null) {
                    // 请求数据
                    let response = await this.$api.UserManagement.queryNotInRole(
                        {
                            id: id
                        }
                    );
                    let data = response.data;
                    let result = [];
                    for (let i = 0; i < data.length; i++) {
                        result.push({
                            key: data[i].id,
                            label: data[i].name,
                            disabled: false
                        });
                    }
                    this.notInRole = result;
                } else {
                    return [];
                }
            },
            async queryInRole (id) {
                if (id != null) {
                    let response = await this.$api.UserManagement.queryInRole({
                        id: id
                    });
                    let data = response.data;
                    let result = [];
                    for (let i = 0; i < data.length; i++) {
                        result.push(data[i].id);
                    }
                    this.targetKeys = result;
                } else {
                    return [];
                }
            }
        };
    },
    mounted () {
        // 创建一个查询的Bean
        let queryBean = this.buildQueryBean();
        this.loadTable(queryBean);
    },
    methods: {
        /**
         * @author: liuc
         * @description: 获取分页信息： total pageSize currentPage
         * @param {data} 分页信息
         */
        paginationInfo (data) {
            this.total = Number(data.total);
            this.pageSize = data.pageSize;
            this.currentPage = data.pageNum;
        },
        /**
         * @author: liuc
         * @description:打开编辑用户
         * @param {id} 用户id
         */
        showDialog (id) {
            this.$emit('showDialog', id);
        },
        /**
         * @author: liuc
         * @description: 分页组件上的：上一页/下一页/页码输入框
         * @param {cp} 当前页码
         */
        changePage (cp) {
            this.currentPage = cp;
            this.$emit('loadlist', cp);
        },
        /**
         * @author:
         * @description:打开删除提醒
         * @param {number} index 列表中第几项
         * @param {id} id
         */
        async DeleteShow (index, id) {
            this.$confirm('确认删除？', '警告', { type: 'warning' })
                .then(async () => {
                    let response = await this.$api.UserManagement.deleteUser(
                        id
                    );
                    if (response.code == 200) {
                        this.$message.success('删除成功');
                    }
                    // 当删除的记录是最后一页的第一条时,删除后刷新列表到第一页
                    var lastPage =
                        this.total % this.pageSize == 0
                            ? this.total / this.pageSize
                            : Math.floor(this.total / this.pageSize) + 1;
                    if (this.currentPage == lastPage && index == 0) {
                        this.currentPage = 1;
                    }
                    this.$emit('loadlist', this.currentPage);
                })
                .catch(() => {});
        },
        /**
         * @author: liuc
         * @description: 加载表格数据
         * @param {queryBean}: 分页参数
         */
        async loadTable (queryBean) {
            // 请求数据
            let response = await this.$api.UserManagement.getUserList(
                queryBean
            );
            if (response.code == 200) {
                this.loading = false;
            }
            this.tableData = response.data.list;
            this.paginationInfo(response.data);
        },
        /**
         * @author: liuc
         * @description: 分页组件上每页显示条数
         * @param {val} 每页条数
         */
        handleSizeChange (val) {
            this.$parent.pageSize = val;
            this.$emit('loadlist', this.currentPage);
        },
        /**
         * @author: liuc
         * @description: 新增、编辑后刷新表格
         * @param {}
         */
        async loadTableRefresh () {
            this.$emit('loadlist', this.currentPage);
        },
        /**
         * @author: liuc
         * @description: 给用户下发角色
         * @param {}:
         */
        async distributionRole () {
            let response = await this.$api.UserManagement.distributionRole({
                id: this.userKey,
                roleList: this.targetKeys
            });
            if (response.code == 200) {
                this.$message.success('用户配置角色成功');
            }
            this.roleDialogVisible = false;
            this.$emit('loadlist', this.currentPage);
        },
        /**
         * @author: liuc
         * @description: 显示角色下发页面
         * @param {index}: 下标值
         * @param {rows}: 当前行数
         */
        showAddRole (index, rows) {
            // 用户主键
            let id = rows[index].id;
            this.userKey = id;
            this.queryNotInRole(id);
            this.queryInRole(id);
            this.roleDialogVisible = true;
        },
        /**
         * @author: liuc
         * @description: 禁用/启用菜单
         * @param {data} 菜单信息
         */
        disableOrEnableUser (data) {
            if (data != null) {
                var message =
                    data.status == 1
                        ? '确认要禁用该用户吗?'
                        : '确认要启用该用户吗？';
                this.$confirm(message, '警告', { type: 'warning' })
                    .then(async () => {
                        let response = await this.$api.UserManagement.disableOrEnableUser(
                            data
                        );
                        this.$message.success(response.msg);
                        this.$emit('loadlist', this.currentPage);
                    })
                    .catch(() => {});
            }
        },
        /**
         * @author: liuc
         * @description: 格式化角色数据
         * @param {row}: 数据信息
         */
        formatter (row) {
            const arrayList = row.roleArrayList;
            var text = '';
            if (arrayList) {
                for (var i = 0; i < arrayList.length; i++) {
                    text += ' ' + arrayList[i].name;
                }
            }

            return text == '' ? '无角色' : text;
        },
        /**
         * @author: liuc
         * @description: 格式化所属机构数据
         * @param {row}: 数据信息
         */
        formatterGroup (row) {
            const arrayList = row.groupArrayList;
            var text = '';
            // 所属机构为根节点
            if (arrayList.length == 1) {
                text += arrayList[0].name;
            } else {
                // 所属机构不是，不显示根节点名字，拼串防止过长
                for (var i = 0; i < arrayList.length - 1; i++) {
                    if (arrayList[i] != null) {
                        if (i == 0) {
                            text += arrayList[i].name;
                        } else {
                            text = arrayList[i].name + '/' + text;
                        }
                    }
                }
            }
            return text == '' ? '无' : text;
        }
    }
};
</script>

<style lang="scss" scoped>
.table-list {
    /deep/ .el-loading-mask {
        z-index: 1000;
    }
    .mod-table {
        /deep/ td {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
    }
}
.header {
    .title {
        font-size: 24px;
    }
}
.transfer-wrap {
    /deep/ .el-transfer-panel {
        width: calc(50% - 100px);
        height: 100%;
        /deep/ .el-transfer-panel__body {
            height: 100%;
            /deep/ .el-transfer-panel__list.is-filterable {
                height: 78%;
            }
        }
        /deep/ .el-transfer-panel__item.el-checkbox {
            display: block !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ./src/components/UserManagement/List.vue